import React from 'react';
interface IconCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
export function IconCard({
  icon,
  title,
  description
}: IconCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-xl transition-shadow duration-300" data-id="element-352">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-[#E63946] bg-opacity-10 rounded-full mb-4" data-id="element-353">
        <div className="text-[#E63946]" data-id="element-354">{icon}</div>
      </div>
      <h3 className="text-xl font-bold text-[#0B1F3A] mb-3" data-id="element-355">{title}</h3>
      <p className="text-gray-600" data-id="element-356">{description}</p>
    </div>;
}